import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import Button from "../../components/Button";
import { Toolbar, ToolbarGroup } from "../../components/Toolbar";
import {
  campaignsList,
  emailsList,
  emailsListClear,
  openModal,
} from "../../actions";
import { history } from "../../history";

export class ListCampaignToolbar extends Component {
  constructor(props) {
    super(props);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.searchRef = createRef();
  }

  componentDidMount() {
    if (this.searchRef?.current) {
      this.searchRef.current.focus();
      this.searchRef.current.selectionStart =
        this.searchRef.current.selectionEnd =
          this.searchRef.current.value.length;
    }
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    if (searchTerm.length > 0) {
      this.props.emailsList(
        this.props.accountId,
        {
          name: searchTerm,
        },
        true
      );
      this.props.campaignsList(
        this.props.accountId,
        {
          name: searchTerm,
        },
        false,
        true
      );
    } else {
      this.props.campaignsList(
        this.props.accountId,
        {
          campaign: "root",
        },
        "root",
        true
      );
      this.props.emailsListClear();
    }

    history.push(
      `${window.location.pathname}?name=${encodeURIComponent(searchTerm)}`
    );
  }

  openCreateModal() {
    const { accountId } = this.props;

    this.props.openModal("create-campaign", {
      accountId,
    });
  }

  render() {
    const { searchTerm } = this.props;

    return (
      <Toolbar>
        <ToolbarGroup>
          <input
            ref={this.searchRef}
            placeholder="Search"
            style={{ width: "100%" }}
            onChange={this.onSearch}
            defaultValue={searchTerm}
          />
        </ToolbarGroup>

        <ToolbarGroup width="160px" align="right">
          <Button onClick={this.openCreateModal}>Create Folder</Button>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

ListCampaignToolbar.propTypes = {
  openModal: PropTypes.func.isRequired,
};

// Connect actions
export default connect(null, {
  campaignsList,
  emailsList,
  emailsListClear,
  openModal,
})(ListCampaignToolbar);
